import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo-name.png";
import rejected from "../assets/rejected.png";
import { useAuth } from "../context/AuthContext";
import { IoIosLogOut } from "react-icons/io";

const SellerRejected = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen w-full flex-col items-center p-5">
      {/* Logo */}
      <div className="flex w-full justify-start">
        <img src={logo} alt="Logo" className="h-14 sm:h-16" />
      </div>

      {/* rejected Image */}
      <div className="flex w-full max-w-md flex-1 flex-col items-center justify-center">
        <img
          src={rejected}
          alt="rejected Access"
          className="w-full max-w-xs object-cover sm:max-w-sm"
        />

        {/* Text Content */}
        <div className="mt-6 flex flex-col items-center gap-4 text-center">
          <h2 className="text-lg font-semibold">
            Your request has been rejected by the admin
          </h2>
          {/* <p className="px-4 text-gray-600">
              This page is not publicly available. To access it, please log in
              first.
            </p> */}

          <NavLink
            onClick={logout}
            to="/"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-[#FFAE00] py-2 text-white transition hover:bg-[#E09C00]"
          >
            <IoIosLogOut className="text-xl" />
            <span>Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SellerRejected;
